module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "container"
  }, [_h('div', {
    staticClass: "page-header"
  }, [_h('h4', {
    on: {
      "click": _vm.back
    }
  }, ["全网球 / 资讯"])]), _h('div', {
    staticClass: "row",
    attrs: {
      "style": "margin-top: 20px"
    }
  }, [_h('div', {
    staticClass: "col-md-12"
  }, [_h('router-view')])]), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "page-footer"
  }, [_h('div', {
    attrs: {
      "style": "margin-top: 20px"
    }
  }, [_h('p', [_h('a', {
    attrs: {
      "href": "http://www.beian.miit.gov.cn"
    }
  }, ["沪ICP备15042402号-2 | "]), _h('a', {
    attrs: {
      "href": "http://www.beian.miit.gov.cn"
    }
  }, ["沪ICP备17014264号-1 | "]), _h('a', {
    attrs: {
      "href": "http://www.beian.miit.gov.cn"
    }
  }, ["沪ICP备17014264号-2 "])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2977b738", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2977b738!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 12
// module chunks = 0